import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
// const theme = createTheme({
//   palette: {
//     primary: {
//       main: purple[500],
//     },
//     secondary: {
//       main: green[500],
//     },
//   },
// });

export default createTheme({
  // typography: {
  //         // primary: {
  //         //   main: purple[500],
  //         // },
  //         // secondary: {
  //         //   main: green[500],
  //         // },
  //         fontFamily: "Museo Sans"

  //       },
  //       subtitle1: {
  //         fontFamily: "Museo Sans"
  //         },
  palette: {
    primary: {
      main: "#0a2240",
    },
    secondary: {
      main: red[500],
    },
    text: {
      secondary: "#212121",
    },
    chartBlack: "#333840",
    chartred: "#F07162",
    chartGrey: "#A9B2BD",
    chartOrange: "#FC9D2B",
    chartYellow: "#F8D36A",
    chartBlue: "#5482B3",
    chartATNT: "#00A8E1",
    chartATNTLight: "#a0e0f6ff",
    chartJuice: "#FF8C00",
    chartJuiceLight: "#f4ca97ff",
    chartPrivate: "#FF8C00",
    chartPrivateLight: "#f4ca97ff",
    chartTMobile: "#E20074",
    chartTMobileLight: "#f3b2d3ff"
  },
  typography: {
    fontFamily: ["Montserrat"].join(","),
    fontWeightLight: 100,
    fontWeightRegular: 300,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },

  components: {
    // Name of the component
    MuiTextField: {
      defaultProps: {
        // The props to change the default for.
        sx: {
          "& label": {
            color: "#757575",
          },
          "& .MuiInputLabel-shrink": {
            color: "#212121",
          },

          //ore ripple, on the whole application 💣!
        },
      },
    },

    MuiButton: {
      defaultProps: {
        // The props to change the default for.
        //color: "error",
        //ore ripple, on the whole application 💣!
      },
    },
  },
});
